import { render, staticRenderFns } from "./LivesView.vue?vue&type=template&id=1571736a&"
import script from "./LivesView.vue?vue&type=script&lang=js&"
export * from "./LivesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports